import React from "react";
import { useRouteMatch } from "react-router-dom";

export const useIsListPage = () => {
  const routeMatch = useRouteMatch();

  return routeMatch.path === "/courses/:id/teachers";
};
